module.exports = __webpack_public_path__ + "static/media/broxel-vertical-eng.8af66d61.png";